module.exports = __webpack_public_path__ + "m.no1.cfc1275d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/m.no1.jpg
// module id = 8r/C
// module chunks = 0